module.exports = __webpack_public_path__ + "864a1e9634105de70916a3980ca014a8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-icons/icon-desert.png
// module id = 3657
// module chunks = 0